// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"aq-z","outfitFeedbackSection":"bq-z"};